import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterDrainageObjectDto } from "../../../api";
import { waterDrainageObjectsColumns } from "../form/columns";

interface WaterDrainageObjectFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterDrainageObject: (values: CreateWaterDrainageObjectDto) => void;
}

export const WaterDrainageObjectForm: React.FC<WaterDrainageObjectFormProps> = ({ visible, setVisible, onCreateWaterDrainageObject }) => {
  const [form] = Form.useForm<CreateWaterDrainageObjectDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterDrainageObject}>
        {waterDrainageObjectsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
